import React from "react";

export default function HowToUsePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600  ">
    <div className="max-w-3xl mx-auto py-10 px-4 text-white">
      <h1 className="text-4xl font-bold mb-6">📬 How to Use MBMailer</h1>

      <p className="mb-4">
        MBMailer helps you securely handle contact form submissions without writing
        any backend code. Here's how you can integrate it into your own website or
        application.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">✅ Step 1: Sign Up</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Visit <a href="https://mbmailer.mb-techs.com" className="text-red-600 underline">mbmailer.mb-techs.com</a></li>
        <li>Create an account and verify your email</li>
        <li>Log in to your dashboard</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">✅ Step 2: Get Your API Key</h2>
      <p className="mb-4">
        After logging in, go to your Dashboard and copy your unique API key. You’ll
        need this for your form integration.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">✅ Step 3: Add the Form</h2>
      <p className="mb-2 font-semibold">For HTML/Static Sites:</p>
      <pre className="bg-gray-100 p-4 text-sm overflow-x-auto text-black">
        {`<form action="https://mbmailer.mb-techs.com/mbmailer/form" method="POST">
  <input type="text" name="name" placeholder="Your name" required />
  <input type="email" name="email" placeholder="Your email" required />
  <textarea name="message" placeholder="Your message..." required></textarea>
  <input type="hidden" name="apiKey" value="YOUR_API_KEY_HERE" />
  <input type="hidden" name="redirect" value="https://yourwebsite.com/thank-you" />
  <button type="submit">Send</button>
</form>`}
      </pre>

      <p className="mb-2 font-semibold mt-4">For React Apps (with fetch):</p>
      <pre className="bg-gray-100 p-4 text-sm overflow-x-auto text-black">
        {`const handleSubmit = async (e) => {
  e.preventDefault();
  const res = await fetch("https://mbmailer.mb-techs.com/mbmailer/form", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": "YOUR_API_KEY_HERE",
    },
    body: JSON.stringify({ name, email, message })
  });
  const result = await res.json();
  if (res.ok) alert("Message sent!");
  else alert(result.error || "Failed to send.");
};`}
      </pre>

      <h2 className="text-2xl font-semibold mt-6 mb-2">✅ Step 4: Done!</h2>
      <p className="mb-4">
        You'll receive form submissions directly to your verified email. You can manage
        your API key or regenerate it anytime from your dashboard.
      </p>

      <p className="mt-10 text-sm text-center text-gray-200">
        Need help? Email us at <a href="mailto:support@mb-techs.com" className="underline">support@mb-techs.com</a>
      </p>
    </div>
    </div>
  );
}
